<template>
  <VNavigationDrawer
    v-model="computedDrawer"
    app
    fixed
    persistent
    style="display: flex; flex-direction: column; padding-bottom: 0"
    :hide-overlay="true"
    disable-resize-watcher
    clipped
  >
    <component :is="listTile" />
  </VNavigationDrawer>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import { mapGetters, mapActions } from 'vuex';
import InvoiceListTile from './drawer_list/InvoiceListTile.vue';
import HistoryListTile from './drawer_list/HistoryListTile.vue';
import SettingsListTile from './drawer_list/SettingsListTile.vue';
import MailAttachmentList from './drawer_list/MailAttachmentList.vue';

export default {
  name: 'NavDrawer',
  components: {
    VueDropzone: vue2Dropzone,
    InvoiceListTile,
    HistoryListTile,
    SettingsListTile,
    MailAttachmentList,
  },
  data() {
    return {
      dropzoneOptions: {
        method: 'options',
        url: 'www.google.com',
        thumbnailHeight: 10,
        thumbnailWidth: 10,
        maxFilesize: 10,
        dictDefaultMessage:
          '<i class="material-icons" style="display: block;">cloud_upload</i> Naloži datoteko',
      },
      listTileMap: {
        dashboard: 'InvoiceListTile',
        history: 'HistoryListTile',
        settings: 'SettingsListTile',
        splitting: 'MailAttachmentList',
      },
      isUploading: false,
      search: null,
      debouncedFilterInvoices: null,
      loading: false,
      items: [],
      queue: 0,
      enterpriseName: null,
      fetching: false,
    };
  },
  computed: {
    ...mapGetters([
      'drawerOpened',
      'unProcessedInvoices',
      'activeInvoice',
      'getUser',
      'apiKeyList',
    ]),
    computedDrawer: {
      get() {
        return this.drawerOpened;
      },
      set(value) {
        this.$store.dispatch('setDrawerStateAction', value);
      },
    },
    currentRoute() {
      return this.$route.matched[0].name;
    },
    listTile() {
      return this.listTileMap[this.$route.matched[0].name];
    },
  },
  watch: {
    search(val) {
      if (val) {
        this.debouncedFilterInvoices();
      }
    },
    enterpriseName(val) {
      if (!val) {
        this.search = null;
        this.debouncedFilterInvoices();
      }
    },
  },
  mounted() {
    if (this.getUser) {
      this.getQueueCount();
    }
    this.debouncedFilterInvoices = this._.debounce(this.filterInvoices, 1000);
  },
  methods: {
    ...mapActions([
      'refreshCredentials',
      'addUnprocessedInvoice',
      'uploadFile',
      'setSnackBarStateAction',
      'getFilteredInvoices',
      'getUnprocessedInvoices',
    ]),
    async filterInvoices() {
      try {
        this.loading = true;
        let causeName = '';
        if (this.enterpriseName) {
          causeName = this.enterpriseName.id;
        } else {
          causeName = this.search || '';
        }
        await this.getFilteredInvoices({
          causeName,
          route: this.$route.name,
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchUnprocessedInvoices() {
      try {
        this.fetching = true;
        await this.$store.dispatch('getUnprocessedInvoices');
      } catch (err) {
        console.log(err);
      } finally {
        this.fetching = false;
      }
    },
    uploadError() {
      this.$refs.myVueDropzone.removeAllFiles();
      this.isUploading = false;
    },
    async getQueueCount() {
      this.queue = 50;
    },
  },
};
</script>

<style scoped lang="scss">
.list--scroll {
  overflow: scroll;
  padding: 0;
  flex: 1;
}
::-webkit-scrollbar {
  display: none;
}
.drawer_content_container {
  flex: auto;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}
.dropzone_container {
  flex: 1;
  border-top: solid 1px #e0e0e0 !important;
}
.dropzone_custom {
  border: none;
  height: 250px;
}
.top-right-btn {
  position: absolute;
  right: 0;
  top: 64px;
}
.check_nav_drawer {
  height: calc(100% - 100px) !important;
  margin-top: 64px !important;
  padding: 0 !important;
}
</style>
